import React, { useState, useEffect } from 'react';
import { useLazyQuery, useQuery } from '@apollo/react-hooks';
import { useLocation } from 'react-router-dom';
import gql from 'graphql-tag';

import { tracking } from './__generated__/tracking';
import { Loading } from '../atoms';
import { NoResult } from '@molecules';
import styled from 'styled-components';

export const TRACKING_INFORMATION = gql`
  query tracking($trackingNumber: String!) {
    tracking(trackingNumber: $trackingNumber) {
      data
    }
  }
`;

export const AwbTitle = styled.h3`
  padding: 2rem;
`;

const TrackingPage = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const awb = queryParams.get('awb');

  const [trackingData, setTrackingData] = useState(null);
  const [isError, setIsError] = useState(true);

  const [tracking, { data, loading }] = useLazyQuery<tracking>(TRACKING_INFORMATION, {
    variables: { trackingNumber: awb },
    onCompleted: (data) => {
      const parsedData = JSON.parse(data.tracking.data);
      if (parsedData['status'] == 'Tracking service is temporarily not available') {
        setIsError(true);
      } else {
        setIsError(false);
        setTrackingData(JSON.parse(data.tracking.data)['data']);
      }
    },
  });

  useEffect(() => {
    if (awb) {
      tracking();
    }
  }, []);

  if (!awb) {
    return <NoResult />;
  }

  if (loading) {
    return <Loading />;
  }

  if (isError) {
    return (
      <>
        <AwbTitle>AWB : {awb}</AwbTitle>

        <p>Unable to find tracking information. Please contact to livechat.</p>
      </>
    );
  }

  return (
    trackingData && (
      <>
        <AwbTitle>AWB : {awb}</AwbTitle>

        <table className="table">
          <thead>
            <tr>
              <th>Date Time</th>
              <th>Comment</th>
              <th>Location</th>
            </tr>
          </thead>
          <tbody>
            {trackingData?.['tracking_details']?.[awb]?.['trackingEvents'].map((event, idx) => {
              return (
                <tr key={idx}>
                  <td>{event.datetime}</td>
                  <td>{event.status}</td>
                  <td>{event.location}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </>
    )
  );
};

export { TrackingPage };
